export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解爱豆影视的初衷与愿景
        </p>
        <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="flex-shrink-0 w-20 h-20 rounded-2xl bg-primary-500 flex items-center justify-center">
              <span className="font-heading text-2xl text-background-50">爱豆</span>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground-800 mb-3">
                爱豆影视 — 您的偶像综艺高清在线观看首选平台
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                爱豆影视成立于对偶像综艺与真人秀内容的热爱。我们深知追星族和综艺爱好者的需求 —
                高清画质、流畅播放、无需注册、完全免费。从偶像团体综艺到热门选秀节目，
                从户外真人秀到音乐舞台纯享，我们每日更新海量内容，覆盖200+偶像团体的精彩瞬间。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们的技术团队采用先进的视频加速方案，确保每一位观众都能享受
                不缓冲不卡顿的流畅观影体验。爱豆影视将持续优化平台体验，
                为您带来更多优质综艺内容，成为您追综路上最信赖的伙伴。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}